<template>
  <div class="sollicitation-description">
    <h2>{{ sollicitation.id }}</h2>
    <h5>{{ motif | capitalize }}</h5>

    <button v-if="!displayDesc" class="btn btn-sm btn-primary py-0 mb-1" @click="displayDesc = true"><i
        class="fas fa-angle-double-down"></i></button>
    <button v-if="displayDesc" class="btn btn-sm btn-danger py-0 mb-1" @click="displayDesc = false"><i
        class="fas fa-times"></i></button>
    <div v-if="displayDesc" class="bg-light rounded my-2">
      <p class="font-italic" style="font-size: 10px; right: 2px;">Le {{ timeStampToDate(sollicitation.debut) }} <br>
        Saisi par : {{ sollicitation.saisiPar }} pour {{ sollicitation.libelleReclamant }} via
        {{ sollicitation.provenance }}</p>
      <p>
        {{ sollicitation.description }}
      </p>

      <div v-if="!roleUser.includes('ROLE_GARDIEN')">
        <small class="d-block" v-if="sollicitation.mail"><a :href="'mailto:' + sollicitation.mail">Mail :
            {{ sollicitation.mail }}</a></small>
        <small class="d-block" v-if="sollicitation.telephone"><a :href="'tel:' + sollicitation.telephone">Telephone :
            {{ sollicitation.telephone }}</a></small>
      </div>

      <!--  Responsable Sollicitation     -->
      <hr v-if="responsable && (responsable.telephone || responsable.mail)">
      <p v-if="responsable" class="font-italic mb-1" style="font-size: 12px;">Reponsable : {{ responsable.prenom }}
        {{ responsable.nom }}
      </p>

      <div class="d-flex justify-content-center">

        <!--  Contact responsable    -->
        <div v-if="responsable && responsable.telephone">
          <a v-bind:href="'tel:' + responsable.telephone">
            <button class="btn btn-sm btn-primary mb-1"><i class="fas fa-phone fa-lg"></i></button>
          </a>
        </div>

        <div v-if="responsable && responsable.mail">
          <a v-bind:href="'mailto:' + responsable.mail">
            <button class="btn btn-sm btn-primary mb-1"><i class="far fa-envelope fa-lg"></i></button>
          </a>
        </div>

      </div>
    </div>

    <hr>

    <p>{{ sollicitation.entree == null ? sollicitation.libelleProg : sollicitation.libelleAdresse }}</p>
    <small v-if="logement">{{ logement == "Parties communes" ? logement : sollicitation.libelleModule + " (" + logement
      + ")" }}</small>

    <div><b-badge variant="secondary">{{ libelleEtat }}</b-badge></div>

    <div class="mt-1" v-if="!roleUser.includes('ROLE_GARDIEN')">
      <a :href="'tel:' + linkToTel">
        <button v-if="sollicitation.telephone" style="aspect-ratio: 1/1;"
          class="btn btn-success btn-lg d-inline-block mb-2 mx-4 position-relative fs-6" :alt="sollicitation.telephone">
          <i class="fas fa-phone fa-lg"></i>
          <i class="fas fa-user-secret position-absolute end-0 bottom-0 rounded-circle bg-white text-black fs-7 p-1"
            v-if="maskedCall"></i>
        </button>
      </a>

      <a :href="'mailto:' + sollicitation.mail + '?subject=[' + $officeName + '] Votre sollicitation ' + sollicitation.id">
        <button v-if="sollicitation.mail" class="btn btn-success btn-lg d-inline-block mb-2 mx-4 fs-6"
          style="aspect-ratio: 1/1;" :title="sollicitation.mail"><i class="far fa-envelope fa-lg"></i></button>
      </a>

      <a :href="'https://www.google.com/maps/dir/?api=1&destination=' + sollicitation.gps">
        <button v-if="sollicitation.gps" target="_blank" style="aspect-ratio: 1/1;"
          class="btn btn-secondary btn-lg d-inline-block  mb-2 mx-4 fs-6" alt="Lancer la navigation GPS"><i
            class="far fa-paper-plane fa-lg"></i></button>
      </a>
    </div>

    <div v-show="showPhoto">
      <h3>Photo</h3>
      <p>
        <img alt="photo" height="150" src="https://dummyimage.com/150x150/cccccc/666666.png&text=Photo">
      </p>
    </div>
  </div>
</template>

<script>

import timeStampToDate from "@/js/timestampTranslation";


export default {
  name: "DescriptionSollicitation",
  props: {
    showPhoto: Boolean,
    sollicitation: Object
  },
  data() {
    return {
      displayDesc: false
    }
  },
  methods: {
    timeStampToDate(timestamp) {
      // return new Date(timestamp * 1000).toLocaleDateString();
      return timeStampToDate(timestamp)
    }
  },
  computed: {
    roleUser() {
      return this.$store.getters['user/getRoles']
    },
    categorie() {
      return this.$store.getters['categories/getCategorieById'](this.sollicitation.categorie)?.categorie
    },
    type() {
      let type = this.$store.getters['types/getTypeById'](this.sollicitation.type)
      return (type) ? type.libelle : this.categorie;
    },
    nature() {
      let nature = this.$store.getters['natures/getNatureById'](this.sollicitation.nature)
      return (nature) ? nature.libelle : this.type;
    },
    motif() {
      if (!this.sollicitation.motif)
        return "Chargement en cours"
      let motif = this.$store.getters['motifs/getMotifById'](this.sollicitation.motif)
      if (motif)
        return motif.libelle
      else if (this.nature)
        return this.nature
      else
        return this.sollicitation.motif
    },
    logement() {
      if (this.sollicitation.logement === "" || this.sollicitation.logement === undefined)
        return 'Parties communes'
      else
        return this.sollicitation.logement
    },
    linkToTel() {
      let tel = this.sollicitation.telephone;
      if (this.$store.getters['user/getOptions'].maskedNumber && process.env.VUE_APP_PREFIX_MASKED_NUMBER)
        tel = process.env.VUE_APP_PREFIX_MASKED_NUMBER + tel;
      return tel;
    },
    maskedCall() {
      return this.sollicitation.telephone != this.linkToTel;
    },
    responsable() {
      if (this.sollicitation.responsable && this.$store.getters['collaborateurs/collaborateurs']) {
        return this.$store.getters['collaborateurs/getCollaborateurByID'](this.sollicitation.responsable)
      } else
        return null;
    },
    libelleEtat() {
      if (this.sollicitation.etat == 'C' || this.sollicitation.etat == 'R')
        return "Sollicitation clôturée";
      else
        return null
    }
  },
  async mounted() {

    // Chargement des ressources
    this.$store.dispatch('categories/loadCategoriesFromAPI')
    this.$store.dispatch('types/loadTypesFromAPI')
    this.$store.dispatch('natures/loadNaturesFromAPI')
    this.$store.dispatch('motifs/loadMotifsFromAPI')
    this.$store.dispatch('evenements/loadEvenementsFromAPI')
    this.$store.dispatch('actions/loadActionsFromAPI')
    // Si les collaborateurs n'étaient pas déjà chargés
    this.$store.dispatch('collaborateurs/loadCollaborateurs')
  }
}
</script>

<style scoped>
h2 {
  color: #2c3e50 !important;
}

h3 {
  color: #677f8e;
}

.sollicitation-description {
  margin: 0 15px;
}
</style>
